module.exports = __webpack_public_path__ + "img/icon-globe-black.8a85de7b.svg";